import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";

import { BaseMatDialogContainer } from "./base-mat-dialog.container";

/**
 * Mat dialog container that implements sliding up animation on open and slide down navigation on close.
 */
@Component({
	templateUrl: "./base-mat-dialog.container.html",
	encapsulation: ViewEncapsulation.None,
	// Using OnPush for dialogs caused some G3 sync issues.
	// https://github.com/angular/material2/blob/master/src/lib/dialog/dialog-container.ts#L55
	changeDetection: ChangeDetectionStrategy.Default,
})
export class SlideUpMatDialogContainer extends BaseMatDialogContainer {}
